export default "6a7cdd1af35ac90d.png"